import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog } from '../types'

@Injectable({ providedIn: 'root' })
export class InfographicComponentConverter extends CmsConverterService<InfographicData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      infographic: formData.st_infographic ?? defaultFSCatalog,
      backgroundColor: formData.st_container_color.value?.identifier ?? ''
    } as InfographicData
  }
}

export const INFOGRAPHIC_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, InfographicData>>('InfographicComponentConverter')

export interface InfographicData extends ConvertedComponentData {
  infographic: FsCatalog;
  backgroundColor: string;
}
